import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setQuality } from 'modules/actions/quality';
import { disableAllMenu, isActiveFeedbackReponseModal } from 'modules/actions/statusMenu';
import { disabledTabMoveButton, disabledTabMoveInput, fallbackTabMove} from 'helper/index'

const Response = () => {
  const dispatch = useDispatch();
  const responseMessage = useSelector(state => state.quality.response);

  useEffect(() => {
    let timeout;
    if(responseMessage.length !== 0 && responseMessage[0].text === "평가 및 의견 작성을 완료해주세요.") {
      disabledTabMoveButton();
      disabledTabMoveInput();
      timeout = setTimeout(() => {
        dispatch(setQuality({ response: [] }));
        dispatch(isActiveFeedbackReponseModal());
        fallbackTabMove();
      }, 1500);
    } else if(responseMessage.length !== 0) {
      disabledTabMoveButton();
      disabledTabMoveInput();
      timeout = setTimeout(() => {
        dispatch(setQuality({ response: [] }));
        dispatch(disableAllMenu());
        fallbackTabMove();
      }, 1500);
    }

    // if (responseMessage.length !== 0) {
    //   timeout = setTimeout(() => {
    //     dispatch(setQuality({ response: [] }));
    //     dispatch(disableAllMenu());
    //   }, 1500);
    // }

    return () => {
      clearTimeout(timeout);
    };
  }, [responseMessage.length]);

  return (
    <div className="feedback_bg">
      <div className="feedback_area_res">
        <div className="confirm_box" role='textbox' tabIndex='0' aria-label='소중한 의견 감사합니다.'>
          {responseMessage.map(i => {
            return <p key={i.text}>{i.text}</p>;
          })}
        </div>
      </div>
    </div>
  );
};

export default Response;
